import React from 'react';
import { Col, Form, Row, Tooltip } from 'antd';
import moment from 'moment';
import ResCol from 'components/forms/ResCol';
import { FilterRangePicker, FilterSelect } from 'components';
import InputListSearch from 'components/InputListSearch';
import {
  FileExcelOutlined,
  FilterOutlined,
  LoadingOutlined,
  PrinterOutlined,
  SyncOutlined
} from '@ant-design/icons';
import { useSettingInvoice } from 'core/hooks';

const TODAY = 'Hoje';
const WEEK = 'Semana';
const MONTH = 'Mês';
const YEAR = 'Ano';

const ranges = {
  [TODAY]: [moment(), moment()],
  [WEEK]: [moment().startOf('week'), moment().endOf('week')],
  [MONTH]: [moment().startOf('month'), moment().endOf('month')],
  [YEAR]: [moment().startOf('year'), moment()]
};

const dateTypes = [
  { key: 'creationTime', label: 'Lançamento' },
  { key: 'dateOfCompensation', label: 'Regime de caixa' },
  { key: 'effectiveDate', label: 'Competência' },
  { key: 'dueDate', label: 'Vencimento' },
  { key: 'paymentDate', label: 'Baixa' }
];

const invoiceStatus = [
  { key: 'created', label: 'Não emitida' },
  { key: 'authorized', label: 'Emitida' },
  { key: 'rejected', label: 'Rejeitada' },
  { key: 'canceled', label: 'Cancelada' }
];

const FinancialEntryFilter = ({
  onRefreshPage,
  loading,
  allowSearch,
  onFilterAdvanced,
  onExportExcel,
  exportingExcel,
  onPrint
}) => {
  const { enableInvoice } = useSettingInvoice();

  return (
    <Row align="middle" gutter={[2, 0]}>
      <Col flex={1}>
        <div className="gx-d-flex gx-align-items-center">
          <FilterSelect name="dateType" data={dateTypes} width={140} />
          <Form.Item name="categories" noStyle />
          <Form.Item name="checkingAccounts" noStyle />
          <Form.Item name="costCenters" noStyle />
          <Form.Item name="invoiceStatus" noStyle />
          <Form.Item name="paymentMethods" noStyle />
          <Form.Item name="serviceProviderIds" noStyle />

          <FilterRangePicker name="rangePicker" ranges={ranges} width={240} />

          {enableInvoice && (
            <FilterSelect
              name="invoiceStatus"
              placeholder="Situação da nota"
              data={invoiceStatus}
              allowClear
              width={150}
            />
          )}

          {allowSearch && (
            <InputListSearch
              name="filterText"
              placeholder="Pesquisar..."
              width={170}
            />
          )}

          <Tooltip title="Atualizar lista">
            <SyncOutlined
              className="gx-pointer gx-ml-2"
              onClick={onRefreshPage}
              spin={loading}
            />
          </Tooltip>
          <Tooltip title="Filtro avançado">
            <FilterOutlined
              className="gx-pointer gx-ml-3"
              onClick={onFilterAdvanced}
            />
          </Tooltip>
          <Tooltip title="Exportar em excel">
            {exportingExcel ? (
              <LoadingOutlined className="gx-ml-3 gx-mr-3" />
            ) : (
              <FileExcelOutlined
                className="gx-pointer gx-ml-3 gx-mr-3"
                onClick={onExportExcel}
              />
            )}
          </Tooltip>
          {onPrint ? (
            <Tooltip title="Imprimir">
              <PrinterOutlined className="gx-pointer" onClick={onPrint} />
            </Tooltip>
          ) : null}
        </div>
      </Col>
    </Row>
  );
};

export default FinancialEntryFilter;
